import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsMachineryWinding = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>
        <g fill="currentColor">
          <path
            d="M20.6185532,11.1692657l-0.0000019,0.0000505h-2.5959606v-1.661418h-4.5688658v1.661418h-2.5959597v1.3499022
		l4.0496855,1.142211l-2.6997814,0.7268744l-1.3499022-0.4153605v1.7652397l8.4108829,2.2844458l-2.6997814,0.7268753
		l-5.7111015-1.5575714v0.8306961l4.0496836,1.14221l-2.6997814,0.7268753l-1.3499022-0.4153614v2.0767536h2.5959597v1.7652397
		h4.5688658v-1.6614189h2.5959606V19.995512l-3.0112972,0.8306961h-5.3995886l8.4108858-2.2844467v-1.7652397l-1.3499031,0.3115139
		l-2.6997814-0.7268734l4.0496845-1.142211v-0.8306961l-5.7111025,1.5575705l-2.6997814-0.7268744l8.4108839-2.2844458V11.1692657z
		 M14.2844448,21.6569786h2.9074745v0.8306961h-2.9074745V21.6569786z M14.2844448,10.3386202h2.9074745v0.8306961h-2.9074745
		V10.3386202z M16.4650459,13.1422739l-0.0000019-0.0000257l-4.1535311-1.14221h5.3995886l1.4537258,0.4153605
		L16.4650459,13.1422739z"
          />
          <path
            d="M15.5305023,1.3046833v0.0000237c1.2460575,0,2.3882675,1.0383887,2.3882675,2.3882675
		s-1.0383892,2.3882675-2.3882675,2.3882675v0.8306966c1.7652397,0,3.1151428-1.4537244,3.1151428-3.1151423
		c0-1.7652383-1.4537258-3.1151423-3.1151428-3.1151423c-1.7652397,0-3.1151419,1.4537258-3.1151419,3.1151423h0.8306961
		C13.2460566,2.3430719,14.2844448,1.3046833,15.5305023,1.3046833z"
          />
          <polygon
            points="14.803628,4.7313633 12.9345427,6.0812674 12.9345427,6.7042952 14.803628,8.0541992 15.3228102,7.43117 
		13.8690863,6.3927813 15.2189884,5.3543925 	"
          />
          <rect
            x="3.3814473"
            y="18.2303219"
            width="6.7494669"
            height="0.8306964"
          />
        </g>
      </SvgIcon>
    );
  }
);

export default AppIconsMachineryWinding;
